export default "__VITE_ASSET__a34739a7__"